<div class="modal-backdrop" (click)="dialogRef.close()"></div>
<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <h3 class="modal-title">{{ data.documentType || 'Anexar Documento' }}</h3>
    </div>

    <div class="modal-body">
      <div class="mb-lg text-center">
        <ngx-file-drop [multiple]="false" (onFileDrop)="addAttachment($event)">
          <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <div class="text-center">
              <mat-icon>cloud_upload</mat-icon>
              <p>Arraste seu documento aqui ou</p>
              <button class="btn btn-outline" type="button" (click)="openFileSelector()">
                Selecionar Arquivo
              </button>
              <p class="text-sm text-secondary mt-sm">Formatos suportados: PDF, JPG, PNG. Tamanho máx.: 10MB.</p>
            </div>
          </ng-template>
        </ngx-file-drop>
      </div>

      @if(droppedFile?.fileEntry?.name){
      <div class="alert alert-success mb-md alert-inline">
        <span class="mr-sm">✓</span>
        <div>
          <strong>Arquivo selecionado:</strong> {{ droppedFile?.fileEntry?.name }}
        </div>
      </div>
      }

      @if (!data.documentType) {
      <div class="mb-md">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Tipo do documento</mat-label>
          <input matInput [(ngModel)]="documentName" placeholder="Ex: Comprovante de Residência" />
        </mat-form-field>
      </div>
      }

      <div class="mb-md">
        <mat-checkbox [(ngModel)]="checked" color="primary">Este documento possui data de validade?</mat-checkbox>
      </div>

      @if(checked) {
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Válido até</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="expirationDateselected" readonly (click)="picker.open()" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      }

      @if (isWaiting) {
      <div class="mt-md text-center">
        <div class="spinner"></div>
      </div>
      }
    </div>

    <div class="modal-footer">
      <button class="btn btn-ghost" (click)="dialogRef.close()">Voltar</button>

      <button class="btn btn-primary" (click)="upload()"
        [disabled]="!droppedFile || (!data.documentType && (!documentName || documentName.length < 3)) || isWaiting">
        @if(isWaiting) { Enviando... } @else { Enviar Documento }
      </button>
    </div>
  </div>
</div>
